import { useState } from 'react';
import SectionHeader from './SectionHeader';
import { praises, faqItems } from '../../../mocks/gossip';

export default function About() {
  const [active, setActive] = useState(0);

  return (
    <section id="about" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      {/* 品牌介绍 */}
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <div>
          <SectionHeader eyebrow="关于呱呱吃瓜" title="把每一口瓜，都摆到前排看清" desc="呱呱吃瓜是一个专注娱乐八卦与热点事件的围观现场资讯站。我们不满足于搬运标题，而是把散落的事件脉络、弹幕热评与各方回应整理成一条清晰的时间线。" />
          <div className="flex flex-col gap-4">
            {[
              { icon: 'ri-list-check-3', t: '时间线式复盘', d: '新瓜、发酵、回应、反转逐节点归档，蹲后续不再翻半天评论。' },
              { icon: 'ri-shield-check-line', t: '信源优先核实', d: '重要瓜先比对多方信源再呈现，标注不确定信息，理性第一。' },
              { icon: 'ri-team-line', t: '千万前排吃瓜人', d: '围观现场与评论区实时联动，一个人蹲瓜也不孤单。' },
            ].map((f) => (
              <div key={f.t} className="flex gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xl text-primary-600">
                  <i className={f.icon}></i>
                </span>
                <div>
                  <h3 className="text-base font-bold text-foreground-950">{f.t}</h3>
                  <p className="mt-1 text-sm text-foreground-600">{f.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-lg bg-gradient-to-br from-accent-100 via-background-50 to-secondary-100 p-6 md:p-8">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-double-quotes-l text-3xl text-primary-300"></i>
            </div>
            <p className="mt-2 text-base leading-relaxed text-foreground-800">
              我们相信，吃瓜这件事可以更有秩序、更有温度。呱呱吃瓜想做的，是那个让你点开就能快速进入前排、看得明白也聊得尽兴的围观现场。
            </p>
            <div className="mt-5 flex items-center justify-between border-t border-background-100 pt-4">
              <div className="flex items-center gap-2 text-sm">
                <span className="text-foreground-400">呱呱吃瓜 · 内容组</span>
              </div>
              <div className="flex items-center gap-1 text-secondary-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 用户口碑 */}
      <div className="mt-16">
        <SectionHeader eyebrow="前排口碑" title="蹲瓜网友怎么说" desc="来自围观现场网友的真实反馈，覆盖新用户、老粉与社区守护者。" />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {praises.map((p) => (
            <figure key={p.name} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-1 text-secondary-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">"{p.text}"</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-100 pt-4">
                <img src={p.avatar} alt={`${p.name} 的头像`} title={`${p.name} · 呱呱吃瓜用户`} className="h-10 w-10 rounded-full object-cover" />
                <div className="flex-1">
                  <div className="text-sm font-semibold text-foreground-900">{p.name}</div>
                  <div className="text-xs text-foreground-400">{p.role}</div>
                </div>
                <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-800">{p.tag}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

// FAQ 结构化数据（用于 JSON-LD 注入时读取问题内容）
export { faqItems };